import {FormControl, FormHelperText, Grid, IconButton, Input, InputLabel} from "@material-ui/core";
import {Delete as DeleteIcon, Title as TitleIcon} from "@material-ui/icons";
import React, {useState} from "react";
import {QrCodeSvg} from "../../../../assets";

export const CodeLine = ({ item, idx, updateCode, deleteCode, DragHandle }) => {
    const [showWarning, setShowWarning] = useState(false);
    const [fadingOut, setFadingOut] = useState(false);

    const handleChange = (event) => {
        const value = event.target.value;

        if (value.length > 50) {
            setShowWarning(true);
            setFadingOut(false);

            // Hide the warning after 3 seconds
            setTimeout(() => {
                setFadingOut(true);
                setTimeout(() => {
                    setShowWarning(false);
                }, 1000);  // The duration of the fade-out animation
            }, 3000);
        } else {
            setShowWarning(false);
            updateCode(idx, { ...item, displayName: value });
        }
    };
    return (
        <div style={{ display: "flex"}}>
            <Grid
                alignItems="center"
                style={{
                    display: "flex",
                    flexBasis: "66%",
                    marginTop: "16px",
                    padding: "16px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 2px rgba(60, 70, 89, 0.16)",
                    backgroundColor: "#FFFFFF",
                    maxWidth: "calc(100% - 32px)",
                    boxSizing: "border-box"
                }}
            >

                <Grid style={{display: "flex", height: "56px", alignItems: "flex-end"}}>
                    {DragHandle && <DragHandle />}
                </Grid>
                <Grid
                    item
                    xs={12}
                    style={{
                        width: 'auto',
                        maxWidth: 'calc(100% - 120px)',
                        flexGrow: 0,
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center"}}>
                        <TitleIcon />
                        <FormControl style={{ width: '100%', paddingLeft: "12px" }}>
                            <Input
                                multiline={false}
                                rows={2}
                                onChange={handleChange}
                                style={{minWidth: "100%", maxWidth: "100%", overflow: 'auto'}}
                                value={item.displayName || ''}
                                placeholder={`Title`}
                            />
                            {showWarning && (
                                <FormHelperText
                                    error
                                    style={{
                                        opacity: fadingOut ? 0 : 1,
                                        transition: 'opacity 1s ease-in-out',  // Fade-out effect
                                    }}
                                >
                                    Maximum character limit is 50!
                                </FormHelperText>
                            )}
                        </FormControl>
                    </div>
                    <div style={{ display: "flex", alignItems: "center"}}>
                        <img
                            src={QrCodeSvg}
                            height={24}
                            width={24}
                            title={"Qr Code"}
                        />
                        <FormControl style={{width: "100%", paddingLeft: "12px", paddingBlock: "8px"}}>
                            <Input
                                placeholder={`QR Code`}
                                value={item.label}
                                onChange={(event) => {
                                    updateCode(idx, {...item, label: event.target.value})
                                }}
                                fullWidth
                                inputProps={{
                                    maxLength: 4200,
                                }}
                                style={{minWidth: "100%", maxWidth: "100%", minHeight: "21px", resize: 'both', overflow: 'auto'}}
                                multiline
                                rows={1}
                            />
                        </FormControl>
                    </div>
                </Grid>
                <Grid style={{display: "flex", height: "56px", alignItems: "flex-end"}}>
                    <IconButton
                        style={{ marginLeft: "8px"}}
                        onClick={() => {
                            deleteCode(idx)
                        }}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Grid>
            </Grid>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/containers/Settings/Shop/ManageReceipt/CodeLine.js